interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
  gridExist?: boolean;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const userAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'users_overview.total_users',
        title: 'Total Users',
        description: 'Total Application Users',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'users_overview.new_users',
        title: 'New Users',
        description: 'New Users This Month',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 4 },
    components: [
      {
        key: 'average_group_size.total_groups',
        title: 'Total Groups',
        description: 'Avg Size: ',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_chat_users',
        title: 'Top 10 Chat Users',
        description: 'This pie chart displays the top 10 users who have sent the most messages during the selected time frame.',
        additionalProps: {
          graphHeight: 380,
          height: 500
        },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_groups',
        title: 'Top 10 Chat Groups',
        description: 'This pie chart illustrates the top 10 groups that have received the most messages during the selected time frame.',
        additionalProps: {
          graphHeight: 380,
          height: 500
        },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'average_group_size.average_size',
        title: 'Average Group Size',
        description: 'Average number of participants per group',
        additionalProps: {
          compact: true,
          valueFontSize: '2rem',
          titleFontSize: '0.75rem',
          descriptionFontSize: '0.7rem'
        }
      },
      {
        key: 'new_users_by_date',
        title: 'New Users Created Per Day',
        description: 'This bar chart shows the number of new users who joined each day within the selected date range.',
        additionalProps: {
          dataKeys: ['count'],
          graphHeight: 300,
          height: 440,
          xAxisKey: 'name',
          colors: ['#F59E0B'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Number of Users'
        },
        wrapper: 'Box',
        wrapperProps: { sx: { marginTop: 1 } },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'online_users_heatmap',
        title: 'Concurrent Users Heatmap',
        description: 'This heatmap indicates the hour of the day and the highest number of users that came online during the hour for the selected time frame.',
        additionalProps: {
          height: 600,
          graphHeight: 530,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'online_frequency_distribution',
        title: 'Online Frequency Distribution',
        description: 'This bar chart represents the distribution of users based on how frequently they were online during the selected date range.',
        additionalProps: {
          dataKeys: ['value'],
          xAxisKey: 'name',
          colors: ['#8B5CF6'],
          xAxisTitle: 'Frequency Range',
          yAxisTitle: 'Number of Users',
          height: 500,
          graphHeight: 370
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'online_users_per_day',
        title: 'Online Users Per Day',
        description: 'This line chart shows the number of unique users who were online each day within the selected date range.',
        additionalProps: {
          dataKeys: ['users'],
          xAxisKey: 'name',
          colors: ['#06B6D4'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Unique Users',
          height: 500,
          graphHeight: 370
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'active_group_count',
        title: 'Active Group Count',
        description: 'This graph displays the number of groups that had activity during the selected time frame.',
        additionalProps: {
          dataKeys: ['groups'],
          height: 500,
          graphHeight: 370,
          xAxisKey: 'name',
          colors: ['#06B6D4'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Active Groups'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_groups_by_participants',
        title: 'Top 10 Groups by Participants',
        description: 'This bar chart highlights the top 10 groups with the highest number of participants.',
        additionalProps: {
          dataKeys: ['participants'],
          xAxisKey: 'name',
          colors: ['#10B981'],
          xAxisTitle: 'Group',
          yAxisTitle: 'Participants Count',
          height: 500,
          graphHeight: 370
        },
        gridExist: true
      }
    ]
  }
];